import { Injectable } from '@angular/core';
import { DocumentNode } from 'graphql';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})

export class Queries {
  locationsPaginated(): DocumentNode {
    return gql`
      query getLocations($where: LocationWhereInput, $limit: Int, $offset: Int, $orderBy: LocationOrderByObjectInput) {
        locations: locationsNew(
          where: $where,
          limit: $limit,
          offset: $offset,
          orderBy: $orderBy
        ){
          totalCount
          items {
            id
            name
            archived
            address {
              coords {
                latitude
                longitude
              }
              formattedAddress
            }
            documentNumber
            segments {
              id
            }
          }
        }
      }`;
  }

  searchLocation(): DocumentNode {
    return gql`
      query getSpecificLocation($id:ID!){
        location(id: $id){
          id
          name
          group {
            id
            name
          }
          address{
            postalCode
            streetName
            city
            number
            complement
            neighborhood
            state
            coords{
              latitude
              longitude
            }
            formattedAddress
          }
        }
      }
    `;
  }

  formsPaginated(): DocumentNode {
    return gql`
      query getForms($where: FormWhereInput, $limit: Int, $offset: Int, $orderBy: FormOrderByInput) {
        forms(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            name
            archived
          }
        }
      }`;
  }

  searchForm(): DocumentNode {
    return gql`
      query getFormById($id: ID!) {
        form(id: $id) {
          id
          name
          archived
        }
      }
    `;
  }

  companiesPaginated(): DocumentNode {
    return gql`
      query companiesPaginated(
        $where: CompanyWhereInput
        $orderByDistance: CompanyOrderByDistanceInput
        $limit: Int
        $offset:Int
      ) {
        companies(
          where: $where
          orderByDistance: $orderByDistance
          orderBy: name_asc
          limit: $limit
          offset: $offset
        ) {
          totalCount
          items {
            id
            name
            avatarUrl
            lastLoginAt
            createdAt
            archived
            address {
              coords {
                latitude
                longitude
              }
            }
          }
        }
      }
    `;
  }

  searchCompany(): DocumentNode {
    return gql`
      query searchCompany($id: ID!) {
        company(id: $id) {
          id
          name
          archived
          avatarUrl
          lastLoginAt
          address {
            coords {
              latitude
              longitude
            }
          }
        }
      }
    `;
  }

  companyByConfig(): DocumentNode {
    return gql`
      query companyByConfig($locationId: ID!, $segmentId: ID!, $maintenanceTypeId: ID) {
        companyByConfig(locationId: $locationId, segmentId: $segmentId, maintenanceTypeId: $maintenanceTypeId) {
          id
          name
          archived
          address {
            coords {
              latitude
              longitude
            }
          }
        }
      }
    `;
  }

   deadlineContractByConfig(): DocumentNode {
    return gql`
      query deadlineContractByConfig($locationId: ID!, $segmentId: ID!, $maintenanceTypeId: ID) {
        deadlineContractByConfig(locationId: $locationId, segmentId: $segmentId, maintenanceTypeId: $maintenanceTypeId) {
          id
          name
          archived
        }
      }
    `;
  }

  maintenanceTypesPaginated(): DocumentNode {
    return gql`
      query maintenanceTypesPaginated($where: MaintenanceTypeWhereInput, $orderBy: MaintenanceTypeOrderByInput, $limit: Int, $offset:Int) {
        maintenanceTypes(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            name
            archived
            type
          }
        }
      }
    `;
  }

  searchMaintenanceType(): DocumentNode {
    return gql`
      query searchMaintenanceType($id: ID!) {
        maintenanceType(id: $id) {
          id
          archived
          name
          type
        }
      }
    `;
  }

  usersPaginated(): DocumentNode {
    return gql`
      query getUsers($where:UserWhereInput, $limit: Int, $offset: Int) {
        users(where:$where, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            name
            avatarUrl
          }
        }
      }
    `;
  }

  segmentsPaginated(): DocumentNode {
    return gql`
      query getSegments($where: SegmentWhereInput, $limit: Int, $offset: Int, $orderBy: SegmentOrderByInput) {
        segments(where: $where, limit: $limit, offset: $offset, orderBy: $orderBy) {
          totalCount
          items{
            id
            name
            archived
            maintenanceTypes {
              id
            }
          }
        }
      }`;
  }

  searchSegment(): DocumentNode {
    return gql`
      query searchSegment($id: ID!) {
        segment(id: $id) {
          id
          name
          archived
          maintenanceTypes {
            id
            name
          }
        }
      }
    `;
  }

  searchLocationGroup(): DocumentNode {
    return gql`
      query searchLocationGroup($id: ID!) {
        locationGroup(id: $id) {
          id
          name
          archived
        }
      }
    `;
  }

  maintenanceFilter(): DocumentNode {
    return gql`
      query searchMaintenancesFilter($orderBySegments: SegmentOrderByInput) {
        users (limit: 300, orderBy: name_asc) {
          items {
            id
            name
            type
          }
        }
        segments (limit: 100, orderBy: $orderBySegments) {
          items {
            id
            name
          }
        }
        labels {
          items {
            id
            name
            color
          }
        }
      }
    `;
  }

  maintenancesPaginated(): DocumentNode {
    return gql`
      query maintenancesPaginated($where: MaintenanceWhereInput, $orderBy: MaintenanceOrderByInput, $limit: Int, $offset:Int) {
        maintenances(where: $where, orderBy: $orderBy, limit: $limit, offset: $offset) {
          totalCount
          items {
            id
            number
          }
        }
      }
    `;
  }

  searchMaintenance(): DocumentNode {
    return gql`
      query searchMaintenance($number: string!) {
        maintenances(number: $number) {
          id
          number
        }
      }
    `;
  }

  searchPendencyTypes(): DocumentNode {
    return gql`
      query searchPendencyTypes($where: PendencyTypeWhereInput, $limit: Int, $offset: Int) {
       pendencyTypes(
         where: $where
         orderBy: name_asc
         limit: $limit
         offset: $offset){
         items {
           id
           name
           archived
         }
       }
     }
    `;
  }
}
